(() => {
  const locale = document.documentElement.lang || '';
  const isZh = locale.toLowerCase().startsWith('zh');
  const isJa = locale.toLowerCase().startsWith('ja');
  const root = isZh ? '/zh-jp' : isJa ? '/ja-jp' : '/en-jp';
  const quote = `${root}/pages/contact?view=quote`;
  const localizeChrome = () => {
    document.querySelectorAll('header a, header-menu a, header-drawer a, .header a').forEach((link) => {
      const text = link.textContent.trim().replace(/\s+/g,' ');
      if (/^(Mt\. Fuji|Mount Fuji|富士山之旅|富士山ツアー)$/i.test(text)) {
        const item = link.closest('li') || link;
        item.hidden = true;
        item.style.setProperty('display','none','important');
      }
      if (/^(Pricing|价格|價格|報價|料金)$/i.test(text)) link.href = quote;
      if (/^(Contact|联系我们|聯絡我們|お問い合わせ)$/i.test(text)) link.href = `${root}/pages/contact`;
      if (isZh) {
        const replacements = { 'Home':'首頁','Private Tours':'私人旅遊','Airport Transfer':'機場接送','Pricing':'報價','About Us':'關於我們','Contact':'聯絡我們','Mt. Fuji':'富士山旅遊','Mount Fuji':'富士山旅遊','首页':'首頁','私人包车游':'私人包車遊','机场接送':'機場接送','价格':'報價','價格':'報價','关于我们':'關於我們','联系我们':'聯絡我們' };
        if (replacements[text]) link.textContent = replacements[text];
      }
    });
    document.querySelectorAll('option,[role="option"],localization-form button,localization-form a').forEach((el) => {
      if (el.textContent.includes('简体中文')) el.textContent = el.textContent.replace('简体中文','繁體中文');
    });
    if (isZh) {
      const textReplacements = {
        '跳到内容':'跳至內容',
        'Welcome to our store':'歡迎來到 Tokyo Sakura Tour',
        '区域和语言选择器':'地區與語言選擇器',
        'Join our email list':'訂閱最新消息',
        'Get exclusive deals and early access to new products.':'接收旅遊靈感與最新資訊。',
        'Email':'電子郵件',
        '电子邮件':'電子郵件',
        'Email address':'電子郵件地址',
        '电子邮件地址':'電子郵件地址',
        'Sign up':'訂閱',
        '注册':'訂閱',
        '搜索':'搜尋',
        '账户':'帳戶',
        '购物车':'購物車',
        'ZH-CN':'繁中',
        '条款和政策':'條款與政策',
        'Powered by Shopify':'由 Shopify 提供技術支援',
        'Powerd by Shopify':'由 Shopify 提供技術支援',
        ', Powered by Shopify':'，由 Shopify 提供技術支援',
        ', Powerd by Shopify':'，由 Shopify 提供技術支援'
      };
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const value = node.nodeValue.trim();
        if (textReplacements[value]) node.nodeValue = node.nodeValue.replace(value,textReplacements[value]);
      }
      document.querySelectorAll('[aria-label]').forEach((el) => {
        const label = el.getAttribute('aria-label');
        if (label === '区域和语言选择器') el.setAttribute('aria-label','地區與語言選擇器');
      });
      document.querySelectorAll('input[placeholder]').forEach((el) => {
        if (el.placeholder === 'Email address' || el.placeholder === '电子邮件地址') el.placeholder = '電子郵件地址';
      });
    }
  };
  localizeChrome();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; localizeChrome(); });
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
  [250,750,1500].forEach((delay) => setTimeout(localizeChrome,delay));
  document.querySelectorAll('[data-sakura-lightbox-trigger]').forEach((button) => {
    button.addEventListener('click', () => {
      const box = document.querySelector('[data-sakura-lightbox]');
      if (!box) return;
      box.querySelector('img').src = button.querySelector('img').src;
      box.classList.add('is-open');
      box.setAttribute('aria-hidden','false');
      box.querySelector('button').focus();
    });
  });
  const box = document.querySelector('[data-sakura-lightbox]');
  if (box) {
    const close = () => { box.classList.remove('is-open'); box.setAttribute('aria-hidden','true'); };
    box.querySelector('button').addEventListener('click',close);
    box.addEventListener('click',(event)=>{if(event.target===box)close()});
    document.addEventListener('keydown',(event)=>{if(event.key==='Escape')close()});
  }
})();
